import {
  assessmentDeliverySchema,
  assessmentDemoSkillPassSchema,
  assessmentOverviewSchema,
  type AssessmentDemoSkillPass,
  type AssessmentScope,
  assessmentResultSchema,
  assessmentSummarySchema,
  assessmentTeamSchema,
  assessmentVersionSchema,
  type AssessmentPublication,
  type AssessmentSubmission,
} from "@peer-start/platform-contracts";
import { request } from "../../prototype/api/client.js";

export const fetchAssessmentOverview = () => request("/api/assessment-overview", assessmentOverviewSchema);
export const fetchAssessments = () => request("/api/assessments", assessmentSummarySchema.array());
export const fetchAssessment = (id: string) =>
  request(`/api/assessments/${encodeURIComponent(id)}`, assessmentDeliverySchema);
export const fetchLatestAssessment = (id: string, scope?: AssessmentScope) =>
  request(
    `/api/assessments/${encodeURIComponent(id)}/latest${scope ? `?scope=${scope}` : ""}`,
    assessmentResultSchema.nullable(),
  );
export const fetchAssessmentExample = (id: string) =>
  request(`/api/assessments/${encodeURIComponent(id)}/example`, assessmentResultSchema);
export const fetchAssessmentResult = (id: string) =>
  request(`/api/assessment-results/${encodeURIComponent(id)}`, assessmentResultSchema);
export const submitAssessment = (id: string, submission: AssessmentSubmission) =>
  request(`/api/assessments/${encodeURIComponent(id)}/attempts`, assessmentResultSchema, {
    method: "POST",
    body: JSON.stringify(submission),
  });
export const demoPassFocusQuiz = (id: string, input: AssessmentDemoSkillPass) =>
  request(`/api/assessments/${encodeURIComponent(id)}/demo-skill-pass`, assessmentResultSchema, {
    method: "POST",
    body: JSON.stringify(assessmentDemoSkillPassSchema.parse(input)),
  });
export const fetchAssessmentBanks = () => request("/api/manage/assessments", assessmentVersionSchema.array());
export const publishAssessmentBank = (publication: AssessmentPublication) =>
  request("/api/manage/assessments", assessmentVersionSchema, {
    method: "POST",
    body: JSON.stringify(publication),
  });
export const fetchAssessmentTeam = (id: string) =>
  request(`/api/manage/assessments/${encodeURIComponent(id)}/team`, assessmentTeamSchema);
